<template>
    <div v-loading="loading" element-loading-text="Please don't leave the page! It is Paying" style="overflow-x: hidden;">
        <div class="center mb30" style="padding-top: 50px;">
            <p class="black fs38 fw500">{{ $t('step2').toUpperCase() }}</p>
            <span class="backyel dib divide"></span>
        </div>
        <div class="p1">
            <el-steps :active="step" align-center class="mb30" :class="$style.steps">
                <el-step v-for="(item, index) in steps" :key="index" :title="$t('step') + (index + 1)" :description="item.desc"></el-step>
            </el-steps>
            <div v-show="step === 0">
				<floatBall :text="$t('b1')" @saveCallback="saveCallback"></floatBall>
				<uinput :title="$t('pf4') + $t('colon')" v-model="model['employer_name']"></uinput>
				<uinput :title="$t('pf51') + $t('colon')" :half="true" v-model="model['employer_mobile']">
				    <i class="el-icon-phone"></i>
				</uinput>
				<uinput :title="$t('pf41') + $t('colon')" v-model="model['employer_hkid']" placeholder="V0627000(1) "></uinput>
				<br />
				<uinput :title="$t('philippines_worker_mobile') + $t('colon')" v-model="model['philippines_worker_mobile']"></uinput>
				<uinput :title="$t('pf1') + $t('colon')" v-model="model['helper_name']" :half="true"></uinput>
				
				<!-- 一个弹窗提示 -->
				<el-dialog
				  :visible.sync="requiredDialogVisible"
				  :width="requiredDialogWidth"
				  center>
					  <div slot="title" style="background-color: #222a33 !important;border-top-left-radius:15px;border-top-right-radius:15px">
							<p class="white fs32 fw500" style="height: 2.5rem;line-height: 2.5rem;">{{ $t('paymentRequestT') }}</p>
					  </div>
					  <div class="center gray fs18">
						  <div v-show="lang === 'zh'" class="center">
								<p class="fs18 fw500">缺失信息</p>
								<br />
								<div style="color: red;">
									<p :class="$style.reqP">僱主姓名</p>
									<p :class="$style.reqP">客戶電話</p>
									<p :class="$style.reqP">僱主香港身份証號碼</p>
								</div>
								<el-button  type="warning" size="small"  round @click="requiredDialogVisible = false">關閉</el-button>
						  </div>
						  <div v-show="lang === 'en'" class="center">
								<p class="fs18 fw500">Miss information</p>
								<br />
								<div style="color: red;">
									<p :class="$style.reqP">Name of Employer</p>
									<p :class="$style.reqP">Employer mobile</p>
									<p :class="$style.reqP">EMPLOYER HKID NO</p>
								</div>
								<el-button type="warning" size="small"  round @click="requiredDialogVisible = false">Close</el-button>
						  </div>
					  </div>
				</el-dialog>
				
            </div>
            <div v-show="step === 1" class="fw500 bigRadio">
                <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="fs28">{{ $t('aservice') }}</h2>
                <div style="border-bottom: 1px solid #222a33;color:#508098;line-height:2;" class="fs24" :class="$style.step1">
                    <p>{{ $t('renew5') }}</p>
                    <p >{{ $t('renew6') }}</p>
                </div>
                <!-- <h2 style="border-bottom: 1px solid #222a33;line-height: 3;">{{ $t('aservice') }}</h2>
                <div style="margin-top:40px;"><el-radio v-model="model['additional_service']" label="None">{{ $t('none') }}</el-radio></div>
                <div style="margin-top:20px;"><el-radio v-model="model['additional_service']" label="2 Year MaidSafe Insurance">{{ $t('a2y') }}</el-radio></div>
                <p class="yel" :class="$style.incost">+ {{ $t('money') }} ${{ insurancePrice }}</p>
                <p style="margin: 50px 40px;" class="fs24">
                    <a class="link" :href="$service.insurance" target="_blank">{{ $t('insdetail') }}</a>
                </p>
                <div style="border-bottom: 1px solid #222a33;padding: 40px;" class="fs24">
                    {{ $t('renewcost') }}
                    <span style="padding-left: 20px;" class="yel">{{ $t('money') }} 1680</span>
                </div>
                <div style="margin: 40px;">
                    <p class="fs24">{{ $t('total') }}</p>
                    <p class="fs26 yel">{{ $t('money') }} {{ totalPrice }}</p>
                </div> -->
            </div>
            <div v-show="step === 2" class="center">
				<p class="fs18" style="margin-top: 40px;">{{$t('payamount')}}</p>
				<p class="fs24 mb30">${{totalPrice}}</p>
				<p >{{$t('pSelectPay')}}:</p>
				<div :class="$style.verticalrg" style="margin-top: 50px;width: 13.375rem;margin: 0 auto;">
					<el-radio-group v-model="model['payType']">
						<el-radio  label="1" style="margin-bottom: 2.5rem;">
							<img src="../assets/paypay.png" alt="" style="width: 6.25rem;">
							<span class="f1">{{ $t("paypalT1") }}</span>
						</el-radio>
						<br />
						<el-radio  label="2" style="margin-bottom: 2.5rem;">
							<img src="../assets/payment_ATM.png" alt="" style="width: 6.25rem;">
							<span class="f1">{{ $t("paypalT2") }}</span>
						</el-radio>
						<br />
						<el-radio  label="3" style="margin-bottom: 2.5rem;">
							<img src="../assets/payment_FPS.png" alt="" style="width: 6.25rem;">
							<span class="f1">{{ $t("paypalT3") }}</span>
						</el-radio>
						<br />
					</el-radio-group>
					<!-- :class="$style.vertical" -->
					
				</div>
				
                <div v-if="model['payType'] == 1">
					<div style="margin-top: 1.875rem;">
						<p v-if="err" class="red center" style="margin-bottom: 1.25rem;">{{err}}</p>
						<!-- 支付成功後不能再次支付 -->
						<a id='payLinks' href="#" style='display:none;'></a>
						<el-button type="info" size="large" style="width:11.25rem;" @click="onPayClick" :disabled="success">
						    <i class="el-icon-lock"></i>
						    {{$t('pay1')}}</el-button>
						<div v-if="success" class="yellow center" style="margin-top: 1.25rem;">
						    <p>{{ $t('paySuccess1') }}</p>
						    <p>{{ $t('paySuccess2') }}</p>
						    <p>{{ $t('paySuccess3') }}</p>
						</div>
					</div>
				</div>
                <div v-else-if="model['payType'] == 2">
                	<amt></amt>
                </div>
                <div v-else>
                	<fps></fps>
                </div>
				
				<div v-show="model['payType'] != 1" :class="$style.credentialDiv">
					<p style="margin-top: 1.25rem;padding: 0 0.625rem;">{{ $t('amtf1') }}</p>
					<p style="padding: 0 0.625rem;">{{ $t('amtf2') }}</p>
					<div style="margin:1.25rem 0;">
						<span style="margin-right: 1.25rem;">
							<a @click="editAvatar" :class="$style.editbtn">{{$t('pfile')}}</a>
							<input style="display:none;" type="file" accept="image/*" ref="avatar" @change="onFileEdit">
						</span>
						<i v-show="model['credential'] != ''" class="el-icon-delete" style="cursor: pointer;" @click="delFile"></i>
					</div>
					<div>
						<img class="mcenter" :src="model['credential']" alt="" style="max-width: 37.5rem;">
					</div>
					<div style="margin-top: 1.25rem;">
						<el-button type="warning" size="large" style="width:11.25rem;" @click="onSureClick" :disabled="!canSubmit">
							{{$t('confirmOrder')}}
						</el-button>
					</div>
				</div>
				
                
                <template>
                    <p style="margin-top:2.5rem;">{{ $t('afterpay1') }}</p>
                    <p>{{ $t('afterpay2') }}</p>
                </template>
            </div>
            <div v-show="step === 3" class="gray" :class="$style.step3">
                <!-- <img :src="sendfileurl" alt="" style="width: 100%; margin-top:30px;margin-bottom:40px;"> -->
                <h1 class="fs24 center sendInfo">{{$t('l1')}}</h1>
                <div class="dflexx acsb" style="padding: 50px 0px;">
                    <div class="center mb30" style="width:300px;">
                        <img src="../assets/email.png" alt="" width="80">
                        <p class="black mt10">doc@goldenwin.com.hk</p>
                    </div>
                    <div class="center cp" style="width:300px;" @click="goWhatsappPay">
                        <img src="../assets/whatsapp.png" alt="" width="80">
                        <p class="black mt10">{{ $t('w1') }}</p>
                    </div>
                </div>
                <uinfo></uinfo>
            </div>
            <div class="dflex acsb" style="margin-top: 40px;">
                <ubutton :text="$t('pre')" :disabled="!canPre" @click="step--"></ubutton>
                <ubutton v-if="!isLast" :text="$t('next')" :disabled="!canNext" @click="nextClick"></ubutton>
                <ubutton v-else @click="$router.push('/index')" :text="$t('renew4')"></ubutton>
            </div>
        </div>
        <a @click="aClick" ref="btn" style="visbility: hidden;"></a>
    </div>
</template>
<script>
import { format } from 'date-fns';
import {companies} from '../data.js';
import moneyzh from '../assets/money.png';
import moneyen from '../assets/moneyen.png';
import {priceMap} from '../data.js';
import floatBall from '../components/FloatBall.vue';
import amt from '../components/amt.vue';
import fps from '../components/fps.vue';
export default {
    name: 'Payment',
    props: {
        type: String,
        orderId: String,
    },
	components:{
		floatBall,
		amt,
		fps
	},
    data() {
        const lang = this.$i18n.locale;
        const companiesName = companies.map((item) => ({
            value: item.name,
            label: lang === 'en'? item.ename: item.name})
        ) || [];
        const options = [];
        for(let i = 0; i <= 7; ++i) {
            options.push({
                value: i,
                text: i,
                lable: i,
            });
        }
		const tDate = new Date();
		const cDate = new Date();
		cDate.setDate(cDate.getDate() + 6);
		// const hOptions = [];
		// for(let n = 0; n <= 6; ++n) {
		//     hOptions.push({
		//         value: this.$t('pSelectN'+n),
		//         text: this.$t('pSelectN'+n),
		//         lable: this.$t('pSelectN'+n),
		//     });
		// }
        return {
            step: 0,
            steps: [
                {desc: this.$t('step1')},
                {desc: this.$t('aservice')},
                {desc: this.$t('step2')},
                {desc: this.$t('step3')},
            ],
            options,
			// hOptions,
            price: priceMap[this.type] || 0,  // price
            insurancePrice: 1280,
            lang,
            money: lang === 'en' ? moneyen : moneyzh,
            startWork: '1',
            startWorkDate: new Date(),
            companiesName,
            company: companiesName.length > 0 ? companiesName[0].value : '',
            deliveryDate: new Date(),
			tableData:{},
			requiredDialogWidth: '50%',
			requiredDialogVisible: false,
            model: {
                type: this.type,
                helper_code: "",
                helper_name: "",
				philippines_worker_mobile: "",
                salary: "",
                start_work_at: "As soon as possible",
                employer_name: "",
                employer_mobile: "",
                employer_hkid: "",
                nearest_branch: companiesName.length > 0 ? companiesName[0].value : '',
                sign_document_type: 'SF Express',
                mailing_address: "",
                adult_no: '',
                elderly_no: '',
                elderly_healthy_condition: '',
                children_no: '',
                children_age: '',
                expecting_baby: 'N',
				expecting_baby_no: "",
				helperSType: "",
                delivery_date: '',
                house_type: "flat",
                house_size: "",
                bedroom_no: "",
                maid_sleeping: "",
                helper_main_duties: {
                    caring_of_new_born_babies: 'N',
                    caring_of_toddler: 'N',
                    caring_of_children: 'N',
                    gardening: 'N',
                    cooking: 'N',
                    household_chore: 'N',
                    car_washing: 'N',
                    pet_care: '0',
                    car_wash: '0',
                    caring_of_elderly: 'N',
                },
                additional_service: "None",
                remark_1: 'N',
                remark_2: 'N',
				payType: 1,
				credential: "",
            },
            err: '',
            loading: false,
            success: false,
            orderNo: '',
            cancel: false,
            url: '',
			paidate: tDate.toLocaleString('en-US', { month: 'short' }) + " " + tDate.getDate() + " " + tDate.getFullYear(),
			csdate: tDate.toLocaleString('en-US', { month: 'short' }) + " " + cDate.getDate() + " " + cDate.getFullYear(),
			canSubmit: true,
        }
    },
    computed: {
		expectingBabyShow(){
			return this.model.expecting_baby === 'Y' ? true : false;
		},
        formatStartWorkDate() {
            return format(this.startWorkDate, 'MM/dd/yyyy');
        },
        canPre() {
            return this.step !== 0 && !(this.step === 2 && this.orderNo);
        },
        canNext() {
            return this.step !== (this.steps.length - 1);
        },
        isLast() {
            return this.step === (this.steps.length - 1);
        },
        totalPrice() {
            return this.price ? +this.price + (this.model['additional_service'] === 'None' ? 0 : this.insurancePrice) : '-';
        }
    },
    watch: {
        step() {
            this.err = '';
            this.$top();
        },
        success(value) {
            if (value) {
                // this.$notify({
                //     title: this.$t('success'),
                //     message: this.$t('paySuccess'),
                //     type: 'success'
                // });
                this.$alert(this.$t('paySuccess'), this.$t('success'), {
                    type: 'success'
                });
            }
        },
		model:{
			handler(val, oldVal){
				this.postCacheTable();
			},
			deep:true
		}
    },
    created() {
        this.$top();
        this.orderNo = this.$route.query['order_no'];
        this.cancel = this.$route.query['cancel'];
        this.initOrder();
		this.getCacheTable();
    },
    methods: {
		nextClick(){
			if (this.type == 4 && this.step === 0) {
				if (
					this.model.employer_name == '' ||
					this.model.employer_mobile == '' ||
					this.model.employer_hkid == '' 
				) {
					this.requiredDialogVisible = true;
					return
				}
			}
			
			if (this.canSubmit === true && this.step == 2 && this.model.payType != 1) {
				let message =
					this.$i18n.locale === "en" ? 
						"Would you like to book your helper and save your information?If yes,Please click 'Submit'" :
						"請按（提交）以確認為自己選取的女傭";
				this.$message({
					  message: message,
					  type: 'warning',
					  offset: 350,
				});
				return
			}
			
			this.step++
		},
		editAvatar() {
		    this.$refs.avatar.click();
		},
		onFileEdit(files){
			const fileList = this.$refs.avatar.files;
			let reader = new FileReader();     //html5读文件
			reader.readAsDataURL(fileList[0]); //转BASE64
			reader.onload=(e) => {        //读取完毕后调用接口
			    let file = e.target.result;
				this.model['credential'] = file;
			};
		},
		delFile(){
			this.$refs.avatar.value = "";
			this.model['credential'] = "";
		},
		saveCallback(){
			var data = this.model;
			data.startWorkDate = format(this.startWorkDate, 'MM/dd/yyyy');
			data.deliveryDate = format(this.deliveryDate, 'MM/dd/yyyy');
			const params = {
				type:this.type,
				table:JSON.stringify(data)
			}
			this.$service.postCacheTable(params);
		},
        initOrder() {
            if (this.orderNo) {
                this.step = 2;
                if (!this.cancel) {
                    this.err = '';
                    this.loading = true;
                    this.success = false;
                    this.checkOrder(this.orderNo);
                } else { // 取消支付
                    this.$notify({
                        title: this.$t('cancel'),
                        message: this.$t('cancelpay'),
                        type: 'warning'
                    });
                    this.$service.checkPay({order_number: this.orderNo}).then((res) => {
                        this.price = res.data.total_money;
                    })
                    this.err = this.$t('cancelpay');
                }
            } else if (this.orderId) {
                this.step = 2;
            }
        },
        aClick() {
            window.open(this.url);
        },
		onSureClick(){
			this.err = '';
			this.loading = true;
			this.canSubmit = true;
			if (this.model['payType'] != 1 && this.model['credential'] == "") {
				this.loading = false;
				this.$message.error('Non online payment,Please Upload the receipts after you made the payment.');
				return
			}
			
			if (this.model['start_work_at'] === 'formatStartWorkDate') {
			    this.model['start_work_at'] = this.formatStartWorkDate;
			}
			this.model['delivery_date'] = format(this.deliveryDate, 'MM/dd/yyyy');
			this.model['total_money'] = this.totalPrice;
			
			let emptyfi = Object.keys(this.model).find((key) => this.model[key] === undefined);
			// // DIRE HIRE OVERSEAS:   No need to require “Helper Code” to pay
			// if(this.type === '4') {
			//     emptyfi = emptyfi.filter((item) => item != 'helper_code');
			// }
			if (emptyfi && emptyfi.length > 0) {
			    this.loading = false;
				this.$message.error(emptyfi + ' is required');
			} else {
			
			    // let openPay = false; // 防止1000ms报错
			    // var winRef = window.open();
			    this.$service.addContract(this.model).then((res) => {
					this.loading = false;
					this.canSubmit = false;
					this.$message('Submit Success')
			    }).catch((res = {}) => {
						this.$message({
						  message: res.message || 'order error',
						  type: 'error'
						});
			            this.loading = false;
			    });
			}
			
		},
        onPayClick() {
            // window.open('https://www.baidu.com');
            // return;
            this.err = '';
            this.loading = true;
            this.success = false;

            var id = this.orderNo || this.orderId;
            if (id) {
                const params = {order_number: id};
                const payUrl = this.$service.getPay(params);
				let obj = document.getElementById('payLinks');
				obj.href = payUrl;
				obj.click();
                this.checkOrder(id);
                return;
            }

            if (this.model['start_work_at'] === 'formatStartWorkDate') {
                this.model['start_work_at'] = this.formatStartWorkDate;
            }
            this.model['delivery_date'] = format(this.deliveryDate, 'MM/dd/yyyy');
            this.model['total_money'] = this.totalPrice;

            let emptyfi = Object.keys(this.model).find((key) => this.model[key] === undefined);
            // // DIRE HIRE OVERSEAS:   No need to require “Helper Code” to pay
            // if(this.type === '4') {
            //     emptyfi = emptyfi.filter((item) => item != 'helper_code');
            // }
            if (emptyfi && emptyfi.length > 0) {
                this.loading = false;
                this.err = emptyfi + ' is required';
            } else {
                // let openPay = false; // 防止1000ms报错
                // var winRef = window.open();
                this.$service.addContract(this.model).then((res) => {
                    const params = {order_number: res.data['order_number']};
                    const payUrl = this.$service.getPay(params);
					let obj = document.getElementById('payLinks');
					obj.href = payUrl;
					obj.click();
                    // this.$service.pay(params);
                    // winRef.location = this.$service.getPay(params);
                    // openPay = true;
                    this.checkOrder(res.data['order_number']);
                }).catch((res = {}) => {
                    // if (openPay === false) {
                        // winRef.close();
                        this.err = res.message || 'order error';
                        this.loading = false;
                    // }
                });
            }
        },
        checkOrder(orderNo) {
            const _check = (params) => {
                this.$service.checkPay(params).then((res) => {
                    this.price = res.data.total_money;
                    if (res.data.status) { // 支付成功
                        this.loading = false;
                        this.success = true;
                    } else {
                        setTimeout(() => _check(params), 3000);
                    }
                }).catch(() => {
                    this.err = 'error pay';
                    this.loading = false;
                });
            };
            _check({order_number: orderNo});
        },
		getCacheTable(){
			const params = {
				type:this.type
			}
			this.$service.getCacheTable(params).then((res)=>{
				// this.tableData = res.data;
				if(res.status != 200) return;
				var tableData = res.data;
				if(tableData == '') return;
				Object.keys(tableData).forEach(k=>{
					if(typeof(tableData[k]) === 'number'){
						tableData[k] = tableData[k].toString();
					}
					if(k == 'helper_main_duties'){
						if(tableData[k] != ''){
							if(typeof(tableData[k]) === 'object'){
								this.model[k] = tableData[k];
							}
							if(typeof(tableData[k]) === 'string'){
								this.model[k] = JSON.parse(tableData[k]);
							}
						}
					}else if(k == 'startWorkDate'){
						this.startWorkDate = new Date(tableData[k]);
					}else if(k == 'deliveryDate'){
						this.deliveryDate = new Date(tableData[k]);
					}else{
						this.model[k] = tableData[k];
					}
				})
			})
		},
		postCacheTable(){
			const params = {
				type:this.type,
				table:JSON.stringify(this.model)
			}
			this.$service.postCacheTable(params);
		}
    }
}
</script>
<style module>
.editbtn {
	color: #f3b707e6;
	cursor: pointer;
	text-decoration: underline;
	transition:all .4s;
	-moz-transition:all .4s;
	-webkit-transition:all .4s;
	-o-transition:all .4s;
}
.reqP {
	margin-bottom: 0.625rem;
}
.incost {
    margin-top: 10px;
    margin-left: 37px;
    font-size: 20px;
}
.value {
    flex: 1.5;
    padding-left: 10px;
}
.step1 {
    padding: 100px 0px;
}
.step3 {
    margin: 100px;
}
.money {
    width: 40px;
    vertical-align: -3px;
}
.st1 {
	margin: 10px 0;
}
.vertical {
  display: block;
  margin: 20px 0;
}
.verticalrg {
  display: flex;
  flex-direction: column;
}
.credentialDiv {
	background-color: #F5F5F5;
	width: 40.625rem;
	min-height: 12.5rem;
	text-align: center;
	margin: 20px auto;
	padding-top: 10px;
	padding-bottom: 20px;
}
@media screen and (max-width: 770px) {
	.credentialDiv {
		background-color: #F5F5F5;
		width: 20.625rem;
		min-height: 12.5rem;
		text-align: center;
		margin: 20px auto;
		padding-top: 10px;
		padding-bottom: 20px;
	}
    .step1 {
        padding: 30px 0px;
    }
    .step3 {
        margin: 20px;
    }
    .money {
        width: 35px;
        vertical-align: -3px;
    }
}
</style>
